import { render } from "./dental_history.vue?vue&type=template&id=49341b56&scoped=true"
import script from "./dental_history.vue?vue&type=script&lang=js"
export * from "./dental_history.vue?vue&type=script&lang=js"

import "./dental_history.vue?vue&type=style&index=0&id=49341b56&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49341b56"]])

export default __exports__